import React from "react";
import EventCard from "./EventCard";
import { set } from "date-fns";

//import '../Styles/EventCardList.scss';

const EventCardList = ({ eventRegistrationType, campEvents, setWeekSelection, nextPage, setSelectedPage, guestId, setGuestId, duplicateEventError, setDuplicateEventError}) => {
	return (
		<div>
			{ campEvents?.map((campEvent) => <EventCard eventRegistrationType = {eventRegistrationType} 
                                                     campEvent             = {campEvent} 
                                                     setWeekSelection      = {setWeekSelection} 
                                                     nextPage              = {nextPage} 
                                                     setSelectedPage       = {setSelectedPage}
                                                     guestId               = {guestId}
                                                     setGuestId            = {setGuestId}/>)}
		</div>	
	)
}

export default EventCardList;